export const termsAndConditionsForClub = 'terms-and-conditions-for-club'
export const signin = 'signin'
export const join = 'join'

const triggerExternalModal = (modalName): any => {
  window.hm.Remodal.Utils.Actions.showModal(modalName)
}

export default triggerExternalModal
